export default {"src":"/_next/static/media/JointDeformities.411522ab.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};